import React from "react";
import LeftSection from "./LeftSection";
import RightSection from "./RightSection";
import { DiagramEngine } from "@projectstorm/react-diagrams";
import { NENodeModel } from "../Canvas/CustomNode/NENodeModel";

interface MenuSectionProps {
  // isDirty: boolean;
  // handleSaveReset?: any;
  zoomToFit: () => void;
  fitToZoom: () => void;
  printZoom: () => void;
  gridLayout: () => void;
  geoLayout: () => void;
  saveLayout: () => void;
  restoreLayout: () => void;
  engine: DiagramEngine;
}

const MenuSection: React.FC<MenuSectionProps> = ({ zoomToFit, fitToZoom, printZoom, gridLayout, geoLayout, saveLayout, restoreLayout, engine }) => {
  return (
    <div className="menu-section-root no-select">
      <div className="left-menus">
        <LeftSection gridLayout={gridLayout} geoLayout={geoLayout} zoomToFit={zoomToFit} fitToZoom={fitToZoom} printZoom={printZoom} saveLayout={saveLayout} restoreLayout={restoreLayout} engine={engine} />
      </div>
      <div className="right-menus">
        <RightSection />
      </div>
    </div>
  );
};

export default MenuSection;
